var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import PaymentService from '../../api/PaymentService';
import ClientService from '../../api/ClientService';
import GlobalVue from "../../globalVue";
import CollectionDetail from './CollectionDetail.vue';
import PaymentOrder from './PaymentOrder.vue';
var Payment = (function (_super) {
    __extends(Payment, _super);
    function Payment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeName = '0';
        _this.tableHeight = 300;
        _this.total = 0;
        _this.groups = [];
        _this.listData = [];
        _this.formData = {
            group: '',
            text: ''
        };
        return _this;
    }
    Payment.prototype.created = function () {
        this.service = PaymentService.getInstance();
        this.clientService = ClientService.getInstance();
        this.getGroups();
    };
    Payment.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 264;
        }, 300);
        this.getRecords();
    };
    Payment.prototype.getGroups = function () {
        var _this = this;
        this.clientService.getGroups({ isAll: 1 }).then(function (res) {
            var data = res.data.data;
            _this.groups = data || [];
            if (data && data.length) {
                _this.formData.group = data[0].group_id;
            }
        });
    };
    Payment.prototype.getRecords = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var params = {
            group_id: this.formData.group,
            keyword: this.formData.text,
            sort_field: this.order ? this.order[0] : undefined,
            sort_type: this.order ? this.order[1] : undefined
        };
        Object.assign(params, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getCollectionRecords(params).then(function (res) {
            if (res.data.success) {
                _this.listData = res.data.data;
                _this.total = res.data.total;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    Payment.prototype.pageChange = function (pager) {
        this.getRecords();
    };
    Payment.prototype.search = function () {
        this.$refs.pagination.clear();
        this.getRecords();
    };
    Payment.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.getRecords();
    };
    Payment.prototype.toCollectionDetail = function (client) {
        window._czc.push(["_trackEvent", '收款记录', '查看收费明细']);
        GlobalVue.$emit("addTab", {
            component: CollectionDetail,
            title: '收款明细',
            showExist: true,
            name: 'detail_' + client.supplier_to_business_id,
            cprops: {
                clientId: client.supplier_to_business_id.toString(),
                businessId: client.business_id.toString(),
                from_system: client.from_system,
                client: client
            }
        });
    };
    Payment = __decorate([
        Component({
            components: {
                'payment-order': PaymentOrder
            },
            computed: {}
        })
    ], Payment);
    return Payment;
}(Vue));
export default Payment;
